module.exports = __webpack_public_path__ + "img/icon_wenjianpdf.426a2fb0.svg";